export const EMAIL_TEMPLATES_API = "/multitenancy/api/EmailTemplates";

export const MESSAGE_TYPES = [
  { id: "Operations", name: "Operations" },
  { id: "IT", name: "IT" },
  { id: "Sales", name: "Sales" },
];
